/**
 * Pagination and Sources-dropdown rules for Government Opportunities.
 * SPARC/GovEarner: source and search stay on the page-20 server query.
 */

export interface ClientSideOnlyFilterState {
  filterHasDocuments: boolean | null;
  filterTrackingStatus: string;
  dbSearchTerm: string;
  filterDeadlinePreset: string;
  filterProvince: string;
  filterCity: string;
  filterCountry: string;
  selectedDepartmentCount: number;
  filterStatus: string;
}

/**
 * Filters that cannot be expressed on POST /entities/query.
 * Source and the main search box are server filters; they must not force a 5000-row dump.
 */
export function hasClientSideOnlyOpportunityFilters(
  state: ClientSideOnlyFilterState
): boolean {
  return (
    state.filterHasDocuments !== null ||
    state.filterTrackingStatus !== 'all' ||
    state.dbSearchTerm.trim() !== '' ||
    state.filterDeadlinePreset !== 'all' ||
    state.filterProvince !== 'all' ||
    state.filterCity !== 'all' ||
    state.filterCountry !== 'all' ||
    state.selectedDepartmentCount > 0 ||
    state.filterStatus === 'all' ||
    state.filterStatus === 'closed'
  );
}

export function shouldAutoScoreDefaultCatalog(options: {
  isSparcSoftwareDefinedDefault: boolean;
  isDashboardDefaultFilterState: boolean;
  viewMode: string;
  matchScoreCount: number;
  dashboardTotal: number | null | undefined;
}): boolean {
  if (options.isSparcSoftwareDefinedDefault) {
    return false;
  }
  return (
    options.isDashboardDefaultFilterState &&
    options.viewMode !== 'kanban' &&
    options.matchScoreCount === 0 &&
    (options.dashboardTotal == null || options.dashboardTotal <= 200)
  );
}

export function shouldShowSourceInZoneDropdown(
  entityCount: number,
  isWorldZone: boolean
): boolean {
  return isWorldZone || entityCount > 0;
}
